import { questions } from "../data/questions";

export function getFilteredQuestions(idCategory) {
  const questionsList = questions;
  let filteredQuestions = questionsList.filter(
    (el) => el.idCategory === idCategory
  );
  return filteredQuestions;
}
